import logoImg from '@app/assets/full_logo.png'
import { getAuthOptions } from '@app/lib/server'
import { Button, Center, Paper, Stack, Text, useMantineTheme } from '@mantine/core'
import { partial } from 'lodash'
import { GetServerSideProps, type NextPage } from 'next'
import Head from 'next/head'
import Image from 'next/image'
import { getServerSession } from 'next-auth/next'
import { signIn } from 'next-auth/react'
import { useRouter } from 'next/router'
import { setCookie } from 'nookies'
import { useCallback, useEffect } from 'react'

export const getServerSideProps: GetServerSideProps = async ({ req, res }) => {
  // using the context's req/res and next-auth config, get the current user's session (if any)
  const authOptions = getAuthOptions(req.cookies, partial(setCookie, { res }))
  const session = await getServerSession(req, res, authOptions)

  if (session?.user?.id) {
    // if the requested page needs a session but there isn't an authorized user,
    // redirect to login with a callback url to return to the original page
    return {
      redirect: {
        destination: '/dashboard',
        permanent: false
      }
    }
  }

  return {
    props: {}
  }
}

const LoginPage: NextPage = () => {
  const theme = useMantineTheme()
  const router = useRouter()
  const cognitoSignin = useCallback(() => signIn('cognito'), [])

  useEffect(() => {
    if (router.query.sso) {
      cognitoSignin().catch(console.error)
    }
  }, [cognitoSignin, router.query.sso])

  if (router.query.sso) {
    return null
  }

  return (
    <Center
      bg={theme.colors.navy[6]}
      h='100vh'
    >
      <Head>
        <title>UPK / Sign In</title>
      </Head>
      <Paper
        p='xl'
        radius='xl'
      >
        <Stack
          align='center'
          spacing='xl'
        >
          <Image
            alt='Logo'
            height={100}
            src={logoImg}
            priority
          />
          <Text
            fw='bold'
            size='xl'
          >
            MetrixEnroll for Universal Preschool
          </Text>
          <Button
            fullWidth
            onClick={cognitoSignin}
            radius='xl'
            size='lg'
          >
            Login
          </Button>
        </Stack>
      </Paper>
    </Center>
  )
}

export default LoginPage
